import { Box, Typography } from '@mui/material';
import React from 'react';

import searchCustomizationImage from 'assets/images/help-general-search-customization.png';
import pdpCustomizationImage from 'assets/images/help-general-pdp-customization.png';
import customizationOptions from 'assets/images/help-customization-options.png';
import HelpImage from 'ui/help/HelpImage';

// TODO internationalize if we end up caring about it

const HelpCustomizingViews = () => {
  return (
    <Box>
      <Typography variant='body1'>
        There are a few different ways that you can customize your view in this
        application, mostly on the search view, and the product details view.
        Both of which can be accessed via the 'options' button. These
        customizations are independent of one another, so you can adjust the
        search page without affecting the details page, and the details page
        without affecting the search page. You can tailor your experience based
        on these options.
      </Typography>
      <HelpImage
        imageSrc={searchCustomizationImage}
        alt='search page options button location'
      />
      <HelpImage
        imageSrc={pdpCustomizationImage}
        alt='pdp page options button location'
      />
      <Typography variant='body1'>
        Once you get to the customization options, you can decide which
        information you want to be shown, or reset to default views. Applying
        your changes will be immediate, and cancelling will bring you back to
        whatever type of view you had before trying to modify them.
      </Typography>
      <HelpImage
        imageSrc={customizationOptions}
        alt='customization options panel'
      />
    </Box>
  );
};

export default HelpCustomizingViews;
